export default {"src":"/_next/static/media/incorrect_answer_mcq.8110fbbd.svg","height":240,"width":240,"blurWidth":0,"blurHeight":0};